/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import Table from '../components/table/table';
// import TableOrderSort from '../components/table/orderSort';
import ModalComponent from '../components/modal';
import OrdersAction from '../app/store/actions/orders';

import NumbersHelper from '../helpers/numbers';
import TRANSLATE from '../helpers/translate';

class OrdersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      orderFilterName: '',
      orderFilterType: 'TRADITIONAL',
      showModal: false,
      dataType: '',
      initialDate: '',
      finalDate: '',
    };
  }

  componentDidMount() {
    this.searchOrders();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchOrders();
  }

  searchOrders = async () => {
    const {
      search, page, limit, orderBy, field = '', orderFilterType = '',
      initialDate, finalDate,
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.searchItems(limit, skip, search, orderBy, field, orderFilterType, initialDate, finalDate);
  }

  setFilterType = async (orderFieldValue) => {
    const filterOrderLabel = {
      ALL: I18n.t('filterOrderType1'),
      TRADITIONAL: I18n.t('filterOrderType2'),
      PUNCHOUT: I18n.t('filterOrderType3'),
    };

    await this.setState({
      orderFilterName: filterOrderLabel[`${orderFieldValue}`],
      orderFilterType: orderFieldValue,
    });
    await this.searchOrders();
  }

  downloadOrderCsv = async () => {
    await this.props.downloadOrderCsv();
  }

  downloadPendingOrders = async () => {
    await this.props.downloadPendingOrders();
  }

  selectOrder = async (row, type) => {
    try {
      const items = await this.props.getPurchaseItems(row.id);
      if (items) {
        row.items = items;
        await this.setState({ selectItem: row, showModal: true, dataType: type });
      }
    } catch (error) { }
  }

  renderInvoiceButton = (row) => {
    const hasInvoices = row.invoices.length > 0;
    return (
      <React.Fragment>
        {!hasInvoices && (<ReactTooltip place="top" type="dark" effect="solid" />)}
        {hasInvoices ? (
          <button
            type="button"
            className={`btn btn-secondary btn-can-approve ${!hasInvoices ? 'btn-no-invoices' : ''}`}
            onClick={() => {
              if (hasInvoices) {
                this.selectOrder(row, 'invoices');
              }
            }}
            data-tip={I18n.t('visualizeInvoices')}
          >
            <span><Translate value="visualizeInvoices" /></span>
          </button>
        ) : (
          <span style={{ display: 'none' }} />
        )}
      </React.Fragment>
    );
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchOrders();
  }

  render() {
    const {
      limit, page, showModal, selectItem, dataType, orderFilterType,
    } = this.state;
    const { orders = {}, companyTag } = this.props;

    const tableHeader = [
      { key: 'sphereNumber', value: I18n.t('sphereId') },
      { key: 'clientId', value: I18n.t('clientId') },
      { key: 'clientName', value: I18n.t('clientName') },
      { key: 'nickname', value: I18n.t('nickname') },
      { key: 'status', value: I18n.t('status') },
      { key: 'paymentType', value: I18n.t('paymentType') },
      { key: 'paymentStatus', value: I18n.t('paymentStatus') },
      { key: 'providerReturn', value: I18n.t('providerReturn') },
      { key: 'value', value: I18n.t('price') },
      { key: 'createdAt', value: I18n.t('dateHour') },
      { key: 'invoices', value: I18n.t('invoiceDone') },
      { key: 'solicitationUser', value: I18n.t('solicitationUser') },
      { key: 'solicitationDate', value: I18n.t('solicitationDate') },      
      ...(this.props.companyTag === 'nortel' ? [{ key: 'approverEmail1', value: I18n.t('approved1') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'approverDate1', value: I18n.t('dateApproved1') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'statusApprover1', value: I18n.t('statusApprover1') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'approverEmail2', value: I18n.t('approved2') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'approverDate2', value: I18n.t('dateApproved2') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'statusApprover2', value: I18n.t('statusApprover2') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'autoBilling', value: I18n.t('clientAutoBilling') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'orderType', value: I18n.t('type') }] : []),
      ...(this.props.companyTag === 'nortel' ? [{ key: 'minimumBillingDate', value: I18n.t('minBillingDate') }] : []),
      { key: 'action', value: I18n.t('info') },
    ];
    const tableData = (orders.rows || []).map((row, index) => ({
      key: index,
      sphereNumber: row.sphereNumber || I18n.t('notDefined'),
      clientId: row.clientId || I18n.t('notDefined'),
      clientName: row.sphereClient.name,
      nickname: row.client.nickname,
      solicitationUser: row.solicitationUser ? row.solicitationUser.email : 'N/A',
      status: TRANSLATE.orderStatus(row.status),
      paymentType: TRANSLATE.paymentType(row.paymentType) || I18n.t('notDefined'),
      paymentStatus: TRANSLATE.paymentStatus(row.paymentStatus) || I18n.t('notDefined'),
      value: NumbersHelper.toCurrency(row.value) || I18n.t('notDefined'),
      createdAt: row.createdAt,
      providerReturn:
        row.paymentData && row.paymentData.Payment && row.paymentData.Payment.ProviderReturnCode ? row.paymentData.Payment.ProviderReturnCode : '',
      invoices:
        this.renderInvoiceButton(row),
      punchoutEmail: row.punchoutUserIndicatorEmail,
      punchoutName: row.punchoutUserIndicatorName,
      punchoutPhone: row.punchoutUserIndicatorPhone,
      punchoutUnit: row.punchoutUserIndicatorUnit,
      ...(this.props.companyTag === 'nortel' ? { solicitationDate: row.solicitationDate || '' } : {}),
      ...(this.props.companyTag === 'nortel' ? { approverEmail1: row.approverEmail1 || '' } : {}),
      ...(this.props.companyTag === 'nortel' ? { approverDate1: row.approverDate1 || '' } : {}),
      ...(this.props.companyTag === 'nortel' ? { statusApprover1: TRANSLATE.aproverStatus(row.statusApprover1) || '' } : {}),      
      ...(this.props.companyTag === 'nortel' ? { approverEmail2: row.approverEmail2 || '' } : {}),
      ...(this.props.companyTag === 'nortel' ? { approverDate2: row.approverDate2 || '' } : {}),
      ...(this.props.companyTag === 'nortel' ? { statusApprover2: TRANSLATE.aproverStatus(row.statusApprover2) || '' } : {}),
      ...(this.props.companyTag === 'nortel'
        ? { autoBilling: (typeof row.autoBilling === 'boolean' ? (row.autoBilling ? I18n.t('yes') : I18n.t('no')) : '') }
        : {}),
      ...(this.props.companyTag === 'nortel'
        ? { orderType: (typeof row.orderType === 'boolean' ? (row.orderType ? I18n.t('partial') : I18n.t('total')) : '') }
        : {}),
      ...(this.props.companyTag === 'nortel' ? { minimumBillingDate: row.minimumBillingDate } : {}),
      action: (
        <button
          type="button"
          className="btn btn-secondary btn-can-approve "
          onClick={() => this.selectOrder(row, 'orders')}
        >
          <Translate value="visualizeOrder" />
        </button>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <button
          onClick={this.downloadOrderCsv}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="generateCSV" />
        </button>
        <button
          onClick={this.downloadPendingOrders}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="pendingOrdersCSV" />
        </button>
      </React.Fragment>
    );

    const orderFilterSelect = (
      <React.Fragment>
        <select
          onChange={e => this.setFilterType(e.target.value)}
          className="float-right custom-select"
          style={{ width: 'max-Content', height: '34px' }}
          value={orderFilterType === '' ? 'ALL' : orderFilterType}
          required
          disabled={false}
        >
          <option value="ALL">{I18n.t('filterOrderType1')}</option>
          {(this.props.companyTag === 'nortel') ? (
            <React.Fragment>
              <option value="TRADITIONAL">{I18n.t('filterOrderType2')}</option>
              <option value="PUNCHOUT">{I18n.t('filterOrderType3')}</option>
            </React.Fragment>
          ) : (
            <option value="ESTIMATE_FOR_ORDER">{I18n.t('estimateConvertedToOrder')}</option>
          )}
        </select>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        {selectItem && showModal && (
          <ModalComponent
            id="orders"
            type={dataType}
            visible={showModal}
            closeModal={() => { this.setState({ showModal: false }); this.searchOrders(); }}
            items={selectItem}
            titleModal={false}
            bodyModal={false}
            titleOkButtoonModal={I18n.t('exit')}
            size={{ width: '1000px', height: '650px' }}
            showCancel={false}
          />
        )}

        <Table
          title={I18n.t('ordersCheckbuy')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          // extras={this.props.companyTag !== 'dimensional' ? orderFilterSelect : ''}
          filterByDate={(this.props.companyTag === 'chile') ? async (initialDate, finalDate) => {
            await this.setState({ initialDate, finalDate });
            await this.searchOrders();
          } : false}
          alternativeExtras
          page={page}
          perPage={limit}
          count={orders.count && orders.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getOrders: (limit, skip, search, order, field) => dispatch(OrdersAction.getOrders(limit, skip, search, order, field)),
  searchItems: (limit, skip, search, order, field, filter, initialDate, finalDate) => dispatch(
    OrdersAction.getOrders(limit, skip, search, order, field, filter, initialDate, finalDate),
  ),
  getPurchaseItems: purchaseId => dispatch(OrdersAction.getPurchaseItems(purchaseId)),
  downloadOrderCsv: () => dispatch(OrdersAction.downloadOrderCsv()),
  downloadPendingOrders: () => dispatch(OrdersAction.downloadPendingOrders()),
});

const mapStateToProps = state => ({
  orders: state.orders && state.orders.orders,
  companyTag: state.settings.companyTag,
});

export default connect(mapStateToProps, mapDispatchToProps)(OrdersPage);
